import { Component } from 'react';
import { C } from '../data/tokens.js';
import { Ico } from './Ico.jsx';

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary caught:', error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{ padding: "60px 24px", textAlign: "center", minHeight: "60vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 16 }}>
          <div style={{ width: 60, height: 60, background: C.bg2, border: `1px solid ${C.border}`, borderRadius: 16, display: "flex", alignItems: "center", justifyContent: "center" }}>
            <Ico n="warning" size={28} color={C.danger} />
          </div>
          <div style={{ fontFamily: "'Playfair Display',serif", fontSize: 22, fontWeight: 700, color: C.white }}>
            Something went wrong
          </div>
          <div style={{ fontSize: 13, color: C.muted, maxWidth: 260, lineHeight: 1.6 }}>
            {this.state.error.message || "An unexpected error occurred."}
          </div>
          <button
            onClick={() => { this.setState({ error: null }); window.location.reload(); }}
            style={{
              padding: "14px 28px", borderRadius: 14, background: C.gold, color: C.bg0,
              border: "none", fontSize: 15, fontWeight: 700, cursor: "pointer",
              fontFamily: "'DM Sans',sans-serif",
            }}
          >
            Reload app
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}
